<template>
  <div>
    <Modal v-model="show" 
       :width="1300"
	   draggable
       footer-hide
       title="更换地址">
        <Table  :columns="columns" :data="addresses"></Table>
    </Modal>
  </div>
</template>

<script>
import {
    webGetMemberDeliveryAddressByUserIdExt
} from "@/api/modules/sale-management/sale-approve";
export default {
    data(){
        return {
            show:false,
            pIndex:0,
            columns: [
                {
                    title: '联系人',
                    key: 'memberDeliveryAddressContacts'
                },
                {
                    title: '手机号',
                    key: 'memberDeliveryAddressPhone'
                },
                {
                    title: '省',
                    key: 'province'
                },
                {
                    title: '市',
                    key: 'city'
                },
                {
                    title: '区',
                    key: 'dist'
                },
                {
                    title: '详细地址',
                    key: 'memberDeliveryAddressFull'
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 150,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.selectedDeliveryAddress(params.index);
                                    }
                                }
                            }, '选择')
                        ]);
                    }
                }
            ],
            addresses:[]
        };
    },
    mounted(){  
    },
    methods:{
        showModal(index){
            this.show=true;
            this.pIndex=index;
            this.loadMemberDeliveryAddress();
        },
        selectedDeliveryAddress(index) {
            this.show=false;
            this.$emit("handlesSelectedDeliveryAddress", this.addresses[index], this.pIndex);
        },
        loadMemberDeliveryAddress(){
            let realUserUuidStr=localStorage.getItem("realUserUuid");
            if(!realUserUuidStr){
                return;
            }
            webGetMemberDeliveryAddressByUserIdExt({
                userUuid: realUserUuidStr
            }).then(res => {
                if (res.code === 0) {
                    if (res.data.addresses != null) {
                        this.addresses=res.data.addresses;
                    }
                }
            });
        }
    }
};
</script>

<style>

</style>